import React, {Component} from 'react';
import './Scene1.css';
import mp4Home from '../../Resources/home.mp4'
import gsap from "gsap";
import {FormattedMessage} from "react-intl";
import {MenuIcons} from "../menu/MenuIcons";

class Scene1 extends Component<> {
    componentDidMount() {
        gsap.timeline({
            scrollTrigger: {
                refreshPriority: 1,
                trigger: '#scene1',
                start: 'top center',
            }
        }).from([".s1-text-container"], {
            opacity: 0.5,
            duration: 1,
        }).to(MenuIcons, {
            boxShadow: 'var(--iconShadow) white',
            color: 'white',
            duration: 0.5,
        });

        gsap.timeline({
            scrollTrigger: {
                refreshPriority: 1,
                trigger: '#scene1',
                start: 'top -1',
                end: '+=90%',
                scrub: true,
                pin: '#s1',
                pinSpacing: true,
            }
        }).to(".s2-trans", {
            duration: 2,
            bottom: 0,
            height: '80vh',
//            opacity: 0,
        }).to("#s1", {
            duration: 2,
            opacity: 0,
            height: 0,
        }, '0');

        /*
        .from(MenuIcons, {
            opacity: 1,
            filter: 'invert(0)'
        }, '0')
        .from(['#ac', '#at'], {
            backgroundColor: 'white',
            fill: 'black',
        }, '0'); */

//        .to(['#scene2', '#scene3'], {top: '-=90vh',}, '0');
    }

    render() {

        return (
            <section id="scene1" className={'s1-container accessibility-img'}>
                <div className="content">
                    <div id="s1" className={"full-screen clip-all"}>
                        <div className="videobg">
                            <video className={'videobg'} playsInline autoPlay muted loop>
                                <source src={mp4Home} type="video/mp4"/>
                            </video>
                        </div>
                        <div className={'s1-text-full'}>
                            <div className={'s1-text-container'}>
                                <h1>
                                    <span className={"s1-text"}><FormattedMessage id={"home_intro_txt"}/></span>
                                </h1>
                                <h1>
                                    <span className={"s1-text"}><FormattedMessage id={"home_intro_txt_2"}/></span>
                                </h1>
                            </div>
                        </div>
                        <div className={"s2-trans"}/>
                    </div>
                </div>
            </section>
        )
    }
}

export default Scene1;
